import dynamic from "next/dynamic";
import { useContext, useEffect } from "react";
import { newVehicles, vehicles } from "../../../../../src/constants/vehicleData";
import { imagesWEBP } from "../../../../../src/constants/webpImages";
import { Context } from "../../../../../src/context/context";
import { sendAnalytics } from "../../../../../src/utils/analyticsCommon";
import {
  TITLE,
  META_NAME,
  META_CONTENT,
  META_KEYWORDS_NAME,
  META_KEYWORDS_CONTENT,
  KEY_SPECIFICATION_HEADER,
  HIGHLIGHTS_HEADER,
  SUB_TEXT,
  BENEFITS_HEADER,
  VEHICLE_FEATURE_HEADER,
  BRAND_DEALER_HEADER,
  BRAND_DEALER_DESCRIPITION,
  FAQ_HEADER_TEXT,
  H1_HEADING,
} from "../../../../../src/constants/PassengerLandingPageContants/EkaK15";
import Head from "next/head";

const ElectricPassengerVehicleLandingPage = dynamic(
  () =>
    import(
      "../../../../../src/modules/ElectricPassengerVehicleLandingPage/ElectricPassengerVehicleLandingPage"
    ),
  { suspense: true }
);
export default function VehicleModelDetails({
  brand,
  vehicleModel,
  vehicleDataLocal,
}) {
  const noentryData = [
    {
      id: 1,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle1,
    },
    {
      id: 2,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle2,
    },
    {
      id: 3,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle3,
    },
    {
      id: 4,
      imageName: imagesWEBP?.MahindraTreoPlus?.MahindraTreoPlusVehicle4,
    },
  ];
  useEffect(() => {
    sendAnalytics(
      "screen_viewed",
      { screen_name: `electric_commercial_vehicle_4w_${brand}_${vehicleModel}` },
      "en"
    );
  }, [brand, vehicleModel]);

  const state = useContext(Context);
  let location =
    state?.selectedState === "Others" ? "India" : state?.selectedState;
  //We need to add SEO Meta info later
  return ( 
    <>
    <Head>
      <title>Eka K1.5 Price in 2026 - Range, Specification & Reviews | Turno</title>
      <meta
        name="description"
        content="Looking for Eka K1.5 price, range, load capacity, and specifications? Get all the details on this electric commercial vehicle and more at Turno for 2026."
      />
      <meta
        name="keywords"
        content="Eka K1.5, Eka K1.5 price, electric commercial vehicle, Eka electric auto, K1.5 specifications, electric vehicle range, Eka EV, electric commercial vehicle price, Turno"
      />
      <meta name="author" content="Turno" />
      <meta
        name="url"
        content="https://www.turno.club/electric-commercial-vehicles/4w/Eka/K1.5"
      />
      <meta name="robots" content="INDEX,ARCHIVE,FOLLOW" />
      <meta name="lang" content="en" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <link rel="canonical" href="https://www.turno.club/electric-commercial-vehicles/4w/Eka/K1.5" />
    </Head>

      <ElectricPassengerVehicleLandingPage
        title={TITLE}
        metaName={META_NAME}
        metaContent={META_CONTENT}
        brand={brand}
        vehicleModel={vehicleModel}
        location={location}
        vehicleDataLocal={vehicleDataLocal}
        vehicleName={"ekaK15"}
        META_KEYWORDS_NAME={META_KEYWORDS_NAME}
        META_KEYWORDS_CONTENT={META_KEYWORDS_CONTENT}
        KEY_SPECIFICATION_HEADER={KEY_SPECIFICATION_HEADER}
        HIGHLIGHTS_HEADER={HIGHLIGHTS_HEADER}
        SUB_TEXT={SUB_TEXT}
        BENEFITS_HEADER={BENEFITS_HEADER}
        VEHICLE_FEATURE_HEADER={VEHICLE_FEATURE_HEADER}
        BRAND_DEALER_HEADER={BRAND_DEALER_HEADER}
        BRAND_DEALER_DESCRIPITION={BRAND_DEALER_DESCRIPITION}
        FAQ_HEADER_TEXT={FAQ_HEADER_TEXT}
        imagesWEBP={imagesWEBP}
        noentryData={[]}
        H1_HEADING={H1_HEADING}
      />
    </>
  );
}

export const getStaticProps = (context) => {
  let vehicleData = [...vehicles, ...newVehicles];

  const brand = "Eka";
  const vehicleModel = "K1.5";

  let vehicleDataLocal = vehicleData?.filter(function (vehicle) {
    return vehicle?.vehicle_path_id === `${vehicleModel}`;
  });
  let latestVehiclesInfo = vehicleData?.filter((vehicle) => {
    return vehicle?.vehicle_path_id !== `${vehicleModel}`;
  });

  return {
    props: { brand, vehicleModel, vehicleDataLocal, latestVehiclesInfo },
  };
};
